import * as React from "react";
export const FrameCorp = ({ color }) => (
  <svg
    width={256}
    height={217}
    viewBox="0 0 206 197"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M204.536 85.2019L203.169 83.8348L204.536 82.4676L205.903 83.8348L204.536 85.2019Z"
      fill={color}
      fillOpacity={0.05}
    />
    <path
      d="M204.536 108.113L203.169 106.746L204.536 105.379L205.903 106.746L204.536 108.113Z"
      fill={color}
      fillOpacity={0.1}
    />
    <path
      d="M204.536 128.29L203.169 129.657L204.536 131.025L205.903 129.657L204.536 128.29Z"
      fill={color}
      fillOpacity={0.1}
    />
    <path
      d="M204.536 151.201L203.169 152.569L204.536 153.936L205.903 152.569L204.536 151.201Z"
      fill={color}
      fillOpacity={0.05}
    />
    <path
      d="M184.219 62.2908L182.852 60.9236L184.219 59.5565L185.586 60.9236L184.219 62.2908Z"
      fill={color}
      fillOpacity={0.1}
    />
    <path
      d="M184.219 85.2019L182.852 83.8348L184.219 82.4676L185.586 83.8348L184.219 85.2019Z"
      fill={color}
      fillOpacity={0.15}
    />
    <path
      d="M184.219 108.113L182.852 106.746L184.219 105.379L185.586 106.746L184.219 108.113Z"
      fill={color}
      fillOpacity={0.2}
    />
    <path
      d="M184.219 128.29L182.852 129.657L184.219 131.025L185.586 129.657L184.219 128.29Z"
      fill={color}
      fillOpacity={0.15}
    />
    <path
      d="M184.219 151.201L182.852 152.569L184.219 153.936L185.586 152.569L184.219 151.201Z"
      fill={color}
      fillOpacity={0.1}
    />
    <path
      d="M184.219 174.113L182.852 175.48L184.219 176.847L185.586 175.48L184.219 174.113Z"
      fill={color}
      fillOpacity={0.05}
    />
    <path
      d="M163.902 39.3794L162.535 38.0122L163.902 36.6451L165.27 38.0122L163.902 39.3794Z"
      fill={color}
      fillOpacity={0.05}
    />
    <path
      d="M163.902 62.2908L162.535 60.9236L163.902 59.5565L165.27 60.9236L163.902 62.2908Z"
      fill={color}
      fillOpacity={0.15}
    />
    <path
      d="M163.902 85.2019L162.535 83.8348L163.902 82.4676L165.27 83.8348L163.902 85.2019Z"
      fill={color}
      fillOpacity={0.2}
    />
    <path
      d="M163.902 108.113L162.535 106.746L163.902 105.379L165.27 106.746L163.902 108.113Z"
      fill={color}
      fillOpacity={0.25}
    />
    <path
      d="M163.902 128.29L162.535 129.657L163.902 131.025L165.27 129.657L163.902 128.29Z"
      fill={color}
      fillOpacity={0.2}
    />
    <path
      d="M163.902 151.201L162.535 152.569L163.902 153.936L165.27 152.569L163.902 151.201Z"
      fill={color}
      fillOpacity={0.15}
    />
    <path
      d="M163.902 174.113L162.535 175.48L163.902 176.847L165.27 175.48L163.902 174.113Z"
      fill={color}
      fillOpacity={0.1}
    />
    <path
      d="M143.585 16.468L142.218 15.1009L143.585 13.7337L144.952 15.1009L143.585 16.468Z"
      fill={color}
      fillOpacity={0.05}
    />
    <path
      d="M143.585 39.3794L142.218 38.0122L143.585 36.6451L144.952 38.0122L143.585 39.3794Z"
      fill={color}
      fillOpacity={0.2}
    />
    <path
      d="M143.585 62.2908L142.218 60.9236L143.585 59.5565L144.952 60.9236L143.585 62.2908Z"
      fill={color}
      fillOpacity={0.35}
    />
    <path
      d="M143.585 85.2019L142.218 83.8348L143.585 82.4676L144.952 83.8348L143.585 85.2019Z"
      fill={color}
      fillOpacity={0.45}
    />
    <path
      d="M143.585 108.113L142.218 106.746L143.585 105.379L144.952 106.746L143.585 108.113Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M143.585 128.29L142.218 129.657L143.585 131.025L144.952 129.657L143.585 128.29Z"
      fill={color}
      fillOpacity={0.4}
    />
    <path
      d="M143.585 151.201L142.218 152.569L143.585 153.936L144.952 152.569L143.585 151.201Z"
      fill={color}
      fillOpacity={0.3}
    />
    <path
      d="M143.585 174.113L142.218 175.48L143.585 176.847L144.952 175.48L143.585 174.113Z"
      fill={color}
      fillOpacity={0.2}
    />
    <path
      d="M123.269 16.468L121.901 15.1009L123.269 13.7337L124.636 15.1009L123.269 16.468Z"
      fill={color}
      fillOpacity={0.15}
    />
    <path
      d="M123.269 39.3794L121.901 38.0122L123.269 36.6451L124.636 38.0122L123.269 39.3794Z"
      fill={color}
      fillOpacity={0.35}
    />
    <path
      d="M123.269 62.2908L121.901 60.9236L123.269 59.5565L124.636 60.9236L123.269 62.2908Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M123.269 85.2019L121.901 83.8348L123.269 82.4676L124.636 83.8348L123.269 85.2019Z"
      fill={color}
      fillOpacity={0.65}
    />
    <path
      d="M123.269 108.113L121.901 106.746L123.269 105.379L124.636 106.746L123.269 108.113Z"
      fill={color}
      fillOpacity={0.6}
    />
    <path
      d="M123.269 128.29L121.901 129.657L123.269 131.025L124.636 129.657L123.269 128.29Z"
      fill={color}
      fillOpacity={0.55}
    />
    <path
      d="M123.269 151.201L121.901 152.569L123.269 153.936L124.636 152.569L123.269 151.201Z"
      fill={color}
      fillOpacity={0.4}
    />
    <path
      d="M123.269 174.113L121.901 175.48L123.269 176.847L124.636 175.48L123.269 174.113Z"
      fill={color}
      fillOpacity={0.25}
    />
    <path
      d="M102.951 16.468L101.584 15.1009L102.951 13.7337L104.318 15.1009L102.951 16.468Z"
      fill={color}
      fillOpacity={0.3}
    />
    <path
      d="M102.951 39.3794L101.584 38.0122L102.951 36.6451L104.318 38.0122L102.951 39.3794Z"
      fill={color}
      fillOpacity={0.55}
    />
    <path
      d="M102.951 62.2908L101.584 60.9236L102.951 59.5565L104.318 60.9236L102.951 62.2908Z"
      fill={color}
      fillOpacity={0.75}
    />
    <path
      d="M102.951 85.2019L101.584 83.8348L102.951 82.4676L104.318 83.8348L102.951 85.2019Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M102.951 108.113L101.584 106.746L102.951 105.379L104.318 106.746L102.951 108.113Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M102.951 128.29L101.584 129.657L102.951 131.025L104.318 129.657L102.951 128.29Z"
      fill={color}
      fillOpacity={0.6}
    />
    <path
      d="M102.951 151.201L101.584 152.569L102.951 153.936L104.318 152.569L102.951 151.201Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M102.951 174.113L101.584 175.48L102.951 176.847L104.318 175.48L102.951 174.113Z"
      fill={color}
      fillOpacity={0.35}
    />
    <path
      d="M82.6348 16.468L81.2677 15.1009L82.6348 13.7337L84.002 15.1009L82.6348 16.468Z"
      fill={color}
      fillOpacity={0.4}
    />
    <path
      d="M82.6348 39.3794L81.2677 38.0122L82.6348 36.6451L84.002 38.0122L82.6348 39.3794Z"
      fill={color}
      fillOpacity={0.65}
    />
    <path
      d="M82.6348 62.2908L81.2677 60.9236L82.6348 59.5565L84.002 60.9236L82.6348 62.2908Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M82.6348 85.2019L81.2677 83.8348L82.6348 82.4676L84.002 83.8348L82.6348 85.2019Z"
      fill={color}
    />
    <path
      d="M82.6348 108.113L81.2677 106.746L82.6348 105.379L84.002 106.746L82.6348 108.113Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M82.6348 128.29L81.2677 129.657L82.6348 131.025L84.002 129.657L82.6348 128.29Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M82.6348 151.201L81.2677 152.569L82.6348 153.936L84.002 152.569L82.6348 151.201Z"
      fill={color}
      fillOpacity={0.6}
    />
    <path
      d="M82.6348 174.113L81.2677 175.48L82.6348 176.847L84.002 175.48L82.6348 174.113Z"
      fill={color}
      fillOpacity={0.45}
    />
    <path
      d="M62.3174 16.468L60.9503 15.1009L62.3174 13.7337L63.6846 15.1009L62.3174 16.468Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M62.3174 39.3794L60.9503 38.0122L62.3174 36.6451L63.6846 38.0122L62.3174 39.3794Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M62.3174 62.2908L60.9503 60.9236L62.3174 59.5565L63.6846 60.9236L62.3174 62.2908Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M62.3174 85.2019L60.9503 83.8348L62.3174 82.4676L63.6846 83.8348L62.3174 85.2019Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M62.3174 108.113L60.9503 106.746L62.3174 105.379L63.6846 106.746L62.3174 108.113Z"
      fill={color}
    />
    <path
      d="M62.3174 128.29L60.9503 129.657L62.3174 131.025L63.6846 129.657L62.3174 128.29Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M62.3174 151.201L60.9503 152.569L62.3174 153.936L63.6846 152.569L62.3174 151.201Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M62.3174 174.113L60.9503 175.48L62.3174 176.847L63.6846 175.48L62.3174 174.113Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M42.001 16.468L40.6339 15.1009L42.001 13.7337L43.3682 15.1009L42.001 16.468Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M42.001 39.3794L40.6339 38.0122L42.001 36.6451L43.3682 38.0122L42.001 39.3794Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M42.001 62.2908L40.6339 60.9236L42.001 59.5565L43.3682 60.9236L42.001 62.2908Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M42.001 85.2019L40.6339 83.8348L42.001 82.4676L43.3682 83.8348L42.001 85.2019Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M42.001 108.113L40.6339 106.746L42.001 105.379L43.3682 106.746L42.001 108.113Z"
      fill={color}
    />
    <path
      d="M42.001 128.29L40.6339 129.657L42.001 131.025L43.3682 129.657L42.001 128.29Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M42.001 151.201L40.6339 152.569L42.001 153.936L43.3682 152.569L42.001 151.201Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M42.001 174.113L40.6339 175.48L42.001 176.847L43.3682 175.48L42.001 174.113Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M21.6836 16.468L20.3165 15.1009L21.6836 13.7337L23.0508 15.1009L21.6836 16.468Z"
      fill={color}
      fillOpacity={0.5}
    />
    <path
      d="M21.6836 39.3794L20.3165 38.0122L21.6836 36.6451L23.0508 38.0122L21.6836 39.3794Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M21.6836 62.2908L20.3165 60.9236L21.6836 59.5565L23.0508 60.9236L21.6836 62.2908Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M21.6836 85.2019L20.3165 83.8348L21.6836 82.4676L23.0508 83.8348L21.6836 85.2019Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M21.6836 108.113L20.3165 106.746L21.6836 105.379L23.0508 106.746L21.6836 108.113Z"
      fill={color}
    />
    <path
      d="M21.6836 128.29L20.3165 129.657L21.6836 131.025L23.0508 129.657L21.6836 128.29Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M21.6836 151.201L20.3165 152.569L21.6836 153.936L23.0508 152.569L21.6836 151.201Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M21.6836 174.113L20.3165 175.48L21.6836 176.847L23.0508 175.48L21.6836 174.113Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M1.36625 16.468L-0.00089407 15.1009L1.36625 13.7337L2.7334 15.1009L1.36625 16.468Z"
      fill={color}
      fillOpacity={0.7}
    />
    <path
      d="M1.36625 39.3794L-0.00089407 38.0122L1.36625 36.6451L2.7334 38.0122L1.36625 39.3794Z"
      fill={color}
      fillOpacity={0.8}
    />
    <path
      d="M1.36625 62.2908L-0.00089407 60.9236L1.36625 59.5565L2.7334 60.9236L1.36625 62.2908Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M1.36625 85.2019L-0.00089407 83.8348L1.36625 82.4676L2.7334 83.8348L1.36625 85.2019Z"
      fill={color}
      fillOpacity={0.9}
    />
    <path
      d="M1.36625 108.113L-0.00089407 106.746L1.36625 105.379L2.7334 106.746L1.36625 108.113Z"
      fill={color}
    />
    <path
      d="M1.36625 128.29L-0.00089407 129.657L1.36625 131.025L2.7334 129.657L1.36625 128.29Z"
      fill={color}
    />
    <path
      d="M1.36625 151.201L-0.00089407 152.569L1.36625 153.936L2.7334 152.569L1.36625 151.201Z"
      fill={color}
    />
    <path
      d="M1.36625 174.113L-0.00089407 175.48L1.36625 176.847L2.7334 175.48L1.36625 174.113Z"
      fill={color}
      fillOpacity={0.9}
    />
  </svg>
);
